(function () {
  document.querySelectorAll('.primo-btn').forEach(function (button) {
    button.addEventListener('mousedown', function () {
      button.classList.add('is-pressed');
    });
    ['mouseup', 'mouseleave'].forEach(function (evt) {
      button.addEventListener(evt, function () {
        button.classList.remove('is-pressed');
      });
    });
  });

  var nav = document.getElementById('primo-nav');
  var hero = document.getElementById('primo-hero');

  if (nav) {
    function updateNav() {
      var pastHero = hero && window.scrollY > hero.offsetHeight - 100;
      var scrolled = window.scrollY > 48;
      nav.classList.toggle('is-scrolled', window.scrollY > 8);
      nav.classList.toggle('is-solid', scrolled || pastHero);
    }

    window.addEventListener('scroll', updateNav, { passive: true });
    updateNav();
  }

  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var id = anchor.getAttribute('href');
      if (!id || id === '#') return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  document.querySelectorAll('.primo-faq__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));

      document.querySelectorAll('.primo-faq__trigger').forEach(function (other) {
        if (other === trigger) return;
        other.setAttribute('aria-expanded', 'false');
        var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
        if (otherPanel) otherPanel.hidden = true;
      });

      trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (panel) panel.hidden = expanded;
    });
  });

  var stickyCta = document.getElementById('primo-sticky-cta');
  var bookSection = document.getElementById('book-consultation');

  if (stickyCta && bookSection && 'IntersectionObserver' in window) {
    var stickyObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyCta.classList.toggle('is-hidden', entry.isIntersecting);
        });
      },
      { root: null, threshold: 0.15 }
    );
    stickyObserver.observe(bookSection);
  }

  document.querySelectorAll('[data-primo-consult-form]').forEach(function (form) {
    var currentStep = 1;
    var submitText = form.getAttribute('data-submit-text') || 'Request Consultation';
    var webhookUrl = (form.getAttribute('data-webhook-url') || '').trim();
    var panel1 = form.querySelector('[data-step-panel="1"]');
    var panel2 = form.querySelector('[data-step-panel="2"]');
    var successPanel = form.querySelector('[data-success-panel]');
    var progressFill = form.querySelector('[data-progress-fill]');
    var progressLabel = form.querySelector('[data-progress-label]');
    var formError = form.querySelector('[data-form-error]');
    var submitBtn = form.querySelector('[data-submit-btn]');
    var continueBtn = form.querySelector('[data-step-next]');
    var backBtn = form.querySelector('[data-step-back]');
    var dateInput = form.querySelector('[data-field="preferred_date"]');

    function todayIso() {
      var now = new Date();
      var month = String(now.getMonth() + 1).padStart(2, '0');
      var day = String(now.getDate()).padStart(2, '0');
      return now.getFullYear() + '-' + month + '-' + day;
    }

    if (dateInput) {
      dateInput.setAttribute('min', todayIso());
    }

    function getField(name) {
      return form.querySelector('[data-field="' + name + '"]');
    }

    function getFieldWrap(name) {
      var field = getField(name);
      return field ? field.closest('.primo-consult-form__field') : null;
    }

    function setFieldError(name, message) {
      var wrap = getFieldWrap(name);
      var errorEl = form.querySelector('[data-error-for="' + name + '"]');
      var field = getField(name);

      if (wrap) wrap.classList.toggle('is-invalid', Boolean(message));
      if (errorEl) {
        errorEl.textContent = message || '';
        errorEl.hidden = !message;
      }
      if (field) field.setAttribute('aria-invalid', message ? 'true' : 'false');
    }

    function clearErrors() {
      form.querySelectorAll('[data-error-for]').forEach(function (el) {
        el.hidden = true;
        el.textContent = '';
      });
      form.querySelectorAll('.primo-consult-form__field.is-invalid').forEach(function (el) {
        el.classList.remove('is-invalid');
      });
      form.querySelectorAll('[data-field]').forEach(function (field) {
        field.removeAttribute('aria-invalid');
      });
      if (formError) formError.hidden = true;
    }

    function isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    function isValidPhone(value) {
      var digits = value.replace(/\D/g, '');
      return digits.length >= 7;
    }

    function isSunday(dateValue) {
      if (!dateValue) return false;
      var parts = dateValue.split('-');
      var date = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
      return date.getDay() === 0;
    }

    function isPastDate(dateValue) {
      if (!dateValue) return false;
      return dateValue < todayIso();
    }

    function validateStep1() {
      clearErrors();
      var valid = true;
      var firstName = (getField('first_name').value || '').trim();
      var lastName = (getField('last_name').value || '').trim();
      var email = (getField('email').value || '').trim();
      var phone = (getField('phone').value || '').trim();

      if (!firstName) {
        setFieldError('first_name', 'Please enter your first name.');
        valid = false;
      }
      if (!lastName) {
        setFieldError('last_name', 'Please enter your last name.');
        valid = false;
      }
      if (!email) {
        setFieldError('email', 'Please enter your email address.');
        valid = false;
      } else if (!isValidEmail(email)) {
        setFieldError('email', 'Please enter a valid email address.');
        valid = false;
      }
      if (!phone) {
        setFieldError('phone', 'Please enter your phone number.');
        valid = false;
      } else if (!isValidPhone(phone)) {
        setFieldError('phone', 'Please enter a valid phone number.');
        valid = false;
      }

      return valid;
    }

    function validateStep2() {
      clearErrors();
      var valid = true;
      var consultationType = getField('consultation_type').value;
      var preferredDate = getField('preferred_date').value;
      var preferredTime = getField('preferred_time').value;

      if (!consultationType) {
        setFieldError('consultation_type', 'Please select a consultation type.');
        valid = false;
      }
      if (!preferredDate) {
        setFieldError('preferred_date', 'Please choose a preferred date.');
        valid = false;
      } else if (isPastDate(preferredDate)) {
        setFieldError('preferred_date', 'Please choose a future date.');
        valid = false;
      } else if (isSunday(preferredDate)) {
        setFieldError('preferred_date', 'Sundays are unavailable. Please choose another day.');
        valid = false;
      }
      if (!preferredTime) {
        setFieldError('preferred_time', 'Please select a preferred time.');
        valid = false;
      }

      return valid;
    }

    function updateProgress(step) {
      if (progressFill) progressFill.style.width = step === 1 ? '50%' : '100%';
      if (progressLabel) progressLabel.textContent = 'Step ' + step + ' of 2';
    }

    function goToStep(step) {
      currentStep = step;
      if (panel1) panel1.hidden = step !== 1;
      if (panel2) panel2.hidden = step !== 2;
      updateProgress(step);
      if (form.querySelector('.primo-consult-form__progress')) {
        form.querySelector('.primo-consult-form__progress').hidden = false;
      }
    }

    if (continueBtn) {
      continueBtn.addEventListener('click', function () {
        if (!validateStep1()) {
          var firstInvalid = form.querySelector('.primo-consult-form__field.is-invalid [data-field]');
          if (firstInvalid) firstInvalid.focus();
          return;
        }
        goToStep(2);
        var firstStep2Field = panel2 && panel2.querySelector('[data-field]');
        if (firstStep2Field) firstStep2Field.focus();
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        goToStep(1);
        if (formError) formError.hidden = true;
      });
    }

    if (dateInput) {
      dateInput.addEventListener('change', function () {
        if (isSunday(dateInput.value)) {
          setFieldError('preferred_date', 'Sundays are unavailable. Please choose another day.');
        } else if (isPastDate(dateInput.value)) {
          setFieldError('preferred_date', 'Please choose a future date.');
        } else {
          setFieldError('preferred_date', '');
        }
      });
    }

    form.querySelectorAll('[data-field]').forEach(function (field) {
      field.addEventListener('input', function () {
        var name = field.getAttribute('data-field');
        if (name) setFieldError(name, '');
      });
      field.addEventListener('change', function () {
        var name = field.getAttribute('data-field');
        if (name) setFieldError(name, '');
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (currentStep !== 2) return;
      if (!validateStep2()) {
        var firstInvalid = form.querySelector('.primo-consult-form__field.is-invalid [data-field]');
        if (firstInvalid) firstInvalid.focus();
        return;
      }
      if (!webhookUrl) {
        if (formError) formError.hidden = false;
        return;
      }

      var helpField = getField('help_with');
      var budgetField = getField('budget');
      var messageField = getField('message');

      var payload = {
        first_name: getField('first_name').value.trim(),
        last_name: getField('last_name').value.trim(),
        email: getField('email').value.trim(),
        phone: getField('phone').value.trim(),
        consultation_type: getField('consultation_type').value,
        preferred_date: getField('preferred_date').value,
        preferred_time: getField('preferred_time').value,
        help_with: helpField ? helpField.value : '',
        budget: budgetField ? budgetField.value : '',
        message: messageField ? messageField.value.trim() : '',
        source: "Engagement Ring Landing Page"
      };

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';
      }
      if (formError) formError.hidden = true;

      fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Request failed');
          if (panel1) panel1.hidden = true;
          if (panel2) panel2.hidden = true;
          if (form.querySelector('.primo-consult-form__progress')) {
            form.querySelector('.primo-consult-form__progress').hidden = true;
          }
          if (successPanel) successPanel.hidden = false;
        })
        .catch(function () {
          if (formError) formError.hidden = false;
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitText;
          }
        });
    });
  });
})();
